import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import jobPartiesMixin from './jobPartiesMixin'
import { JobApplicationStatuses } from '@/constants/job/jobApplicationStatuses'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [jobPartiesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.jobChat.application.value,
    }),
    isArchived() {
      return this.application.status === JobApplicationStatuses.ARCHIVED
    },
    isMetaArchived() {
      return this.application.meta?.archived
    },
    hasRemoveFromArchiveJob() {
      return !this.isArchived && this.isEmployer && !this.application?.wasStarted && this.isMetaArchived
    },
  },
  methods: {
    ...mapActions({
      updateArchiveApplicationFlag: 'jobChat/updateArchiveApplicationFlag',
    }),
    setArchivedMeta(flag: boolean) {
      return this.updateArchiveApplicationFlag({ applicationId: this.application.id, flag })
    },
  },
})
